import { Outlet } from 'react-router-dom';

import { PwaChrome } from '@/components/pwa/PwaChrome';
import { PwaUpdateProvider } from '@/components/pwa/PwaUpdateProvider';
import { PaymentPrivacyBoundary } from '@/components/analytics/PaymentPrivacyBoundary';

export function RouteChrome() {
  return (
    <PwaUpdateProvider>
      <PaymentPrivacyBoundary />
      <Outlet />
      <PwaChrome />
    </PwaUpdateProvider>
  );
}
